import { render, staticRenderFns } from "./ProducaoCardList.vue?vue&type=template&id=f27f49fc&scoped=true"
import script from "./ProducaoCardList.vue?vue&type=script&lang=ts"
export * from "./ProducaoCardList.vue?vue&type=script&lang=ts"
import style0 from "./ProducaoCardList.vue?vue&type=style&index=0&id=f27f49fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27f49fc",
  null
  
)

export default component.exports